module.exports = __webpack_public_path__ + "static/img/T261030_qb.a3d0829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T261030_qb.png
// module id = Ivlf
// module chunks = 1